




















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import SettingsPriceTemplateForm from "./SettingsPriceTemplateForm.vue";

import SettingsJson from "../../shared/SettingsJson";
import ModulesJson from "../../shared/ModulesJson";

export default Vue.extend({
  name: "SettingsPriceTemplateDetails",
  components: {
    OverlayWindow,
    Loading,
    SettingsPriceTemplateForm,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    priceTemplateId: Number,
  },
  data() {
    return {
      editable: false as boolean,
      detailsTitle: "",
      detailsMode: "",
      loading: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.selectDetailsMode(this.mode);
    },

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Vorlage hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Vorlage bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Vorlage";
          this.editable = false;
          break;
      }
    },
  },
  watch: {},
  computed: {},
});
